"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M12 16.028l2.472 1.472-.656-2.775L16 12.858l-2.876-.245L12 10l-1.124 2.613L8 12.858l2.18 1.867-.652 2.775L12 16.028z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 2l2.413 4.021a8.117 8.117 0 011.174 0L15 2h7l-4.015 6.692a8 8 0 11-11.97 0L2 2h7zm.34 4.453c-.64.225-1.242.53-1.795.901L5.532 4h2.336l1.471 2.453zM7.111 10.52a6 6 0 109.776 6.96 6 6 0 00-9.776-6.96zm9.343-3.166L18.468 4h-2.336L14.66 6.453c.64.225 1.242.53 1.795.901z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;